import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { articles, resourceCategories } from "@/data/resources";

export default function Resources() {
  return (
    <div>
      <section className="pt-16 md:pt-24 pb-16 md:pb-20 border-b border-[#27272a] relative overflow-hidden">
        <div className="absolute inset-0 radial-fade" />
        <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
          <div className="max-w-3xl">
            <div className="eyebrow mb-6">
              <span className="gold-line" />
              The Agent Marketing Playbook
            </div>
            <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl text-white leading-[1.05]">
              Ideas that make marketing <span className="text-[#C8A24B]">easier to do well.</span>
            </h1>
            <p className="mt-8 text-lg text-[#a1a1aa] leading-relaxed max-w-2xl">
              Short, plain-English articles on first impressions, Google
              presence, websites, listing marketing, social media, AI, CRM,
              reviews, referrals, paid ads, SEO, and agency growth.
            </p>
          </div>
        </div>
      </section>

      <section className="py-20 md:py-28">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <div className="text-[10px] tracking-[0.28em] uppercase text-[#71717a] mb-4">
            Categories
          </div>
          <div className="flex flex-wrap gap-2 mb-14">
            {resourceCategories.map((c) => (
              <span
                key={c}
                className="px-3.5 py-2 text-xs border border-[#27272a] rounded-sm text-[#a1a1aa]"
              >
                {c}
              </span>
            ))}
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-2 gap-6 lg:gap-8">
            {articles.map((a) => (
              <Link
                key={a.slug}
                to={`/resources/${a.slug}`}
                data-testid={`resource-card-${a.slug}`}
                className="group border border-[#27272a] hover:border-[#C8A24B]/50 bg-[#0e0e0e] rounded-sm p-8 md:p-10 transition-all"
              >
                <div className="flex items-center justify-between mb-6">
                  <div className="text-[10px] tracking-[0.28em] uppercase text-[#C8A24B]">
                    {a.category}
                  </div>
                  <ArrowUpRight size={16} className="text-[#52525b] group-hover:text-[#C8A24B]" />
                </div>
                <h2 className="font-heading text-2xl md:text-3xl text-white leading-tight mb-3">
                  {a.title}
                </h2>
                <p className="text-[#C8A24B] text-sm mb-4">{a.subtitle}</p>
                <p className="text-[#a1a1aa] leading-relaxed mb-6">{a.excerpt}</p>
                <div className="text-xs text-[#71717a]">{a.readTime}</div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
